import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from '@services/auth.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { MatTabsModule } from '@angular/material/tabs';
import { SwiperModule } from 'swiper/angular';

import { GoogleMapsModule } from '@angular/google-maps';
import { PendingComponent } from '@pages/retailer/pending/pending.component';
import { ComponentsModule } from '@shared/components/components.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { DistributorModule } from '@pages/distributor/distributor.module';
import { TerverifikasiComponent } from '@pages/retailer/terverifikasi/terverifikasi.component';
import { RejectComponent } from '@pages/retailer/reject/reject.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RetailersModule } from '@pages/retailer/retailers.module';
import { MatRadioModule } from '@angular/material/radio';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

@NgModule({
  declarations: [AppComponent, PendingComponent, TerverifikasiComponent, RejectComponent],
  bootstrap: [AppComponent],
  exports: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    ClipboardModule,
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    NgbModule,
    FormsModule,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatTabsModule,
    SwiperModule,
    GoogleMapsModule,
    ComponentsModule,
    MatTableModule,
    MatSortModule,
    DistributorModule,
    MatSnackBarModule,
    RetailersModule,
    MatRadioModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: 'dynamic' },
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
